import styled from 'styled-components';

export const CheckBoxWrapper = styled.div`
  display: flex;
  padding-bottom: 10px;
  align-items: center;
  .typography {
    color: #374065;
    margin-right: 15px;
    margin-left: 10px;
    font-family: 'Roboto';
    font-weight: Bold;
  }
  .error {
    color: red;
    text-align: center;
  }
`;

export const Container = styled.div`
  &&.container {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }
  .MuiPaper-root {
    box-shadow: 0px 1px 3px #0000001f;
  }

  .title {
    text-align: left;
    text-transform: inherit;
    font-size: 18px;
    white-space: nowrap;
    letter-spacing: 0;
    margin-left: 10px;
    margin-bottom: 10px;
    color: #374065;
    display: inline;
    font-weight: 500;
    font-family: Roboto;
  }
  .add-opposingParty {
    position: absolute;
    right: 0;
    top: -38px;
  }
  .add-opposingParty-container {
    position: relative;
  }
  .titleRecap {
    text-align: left;
    text-transform: inherit;
    font-size: 24px;
    white-space: nowrap;
    letter-spacing: 0;
    margin-left: 4px;
    margin-bottom: 30px;
    color: #2b2727;
    display: inline;
    font-weight: 500;
    font-family: Roboto;
  }
  .vehiculeContainer {
    margin-top: 30px;
  }
  .opposingparty-bloc-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: -5px;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
  margin-top: 15px;
  .formEl {
    width: 80%;
    margin-bottom: 5px;
    font-weight: bold;
  }
`;

export const FormSubmitWrapper = styled.div`
  margin-top: 20px;
`;

export const TextWrapper = styled.div`
  display: flex;
  .textBox {
    width: 100%;
    margin-top: 2px;
    margin-bottom: 5px;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 15px;
  .formEl {
    width: 100%;
    margin-bottom: 5px;
    font-weight: bold;
  }
  .error {
    color: red;
    text-align: center;
  }
`;

export const OpposingPartyStyle = styled.div`
  margin-bottom: 20px;
  .sub_div {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: auto;
    background: #f4f4f4 0% 0% no-repeat padding-box;
    border-radius: 5px;
    height: auto;
    box-shadow: 0px 1px 3px #0000001f;
    padding: 0px;
  }
  .opposingParty-head {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f5f5f5 0% 0% no-repeat padding-box;
    border-radius: 4px 4px 0px 0px;
    padding-left: 24px;
    padding-right: 16px;
  }
  .opposingParty-name {
    font-size: 14px;
    font-family: Roboto;
    font-weight: bold;
    letter-spacing: 0px;
    color: #0072c6;
    text-transform: uppercase;
  }
  .collapse-recap {
    height: 50%;
    border-radius: 5px;
    padding: 5px 16px 16px;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .text {
    font-size: 13px;
    letter-spacing: 0;
    font-family: Roboto;
    font-weight: Medium;
    color: #2b2727;
    margin: auto 0 12px 0;
  }
  .action-button {
    width: 160px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .delete-button {
    width: 123px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .add-icon {
    width: 20;
  }
`;
